/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse
 */
export interface UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse
     */
    legalEntitiesUpdated: number;
}

/**
 * Check if a given object implements the UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse interface.
 */
export function instanceOfUploadClientTermsAndConditionsDocumentForWholeOrganizationResponse(value: object): value is UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse {
    if (!('legalEntitiesUpdated' in value) || value['legalEntitiesUpdated'] === undefined) return false;
    return true;
}

export function UploadClientTermsAndConditionsDocumentForWholeOrganizationResponseFromJSON(json: any): UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse {
    return UploadClientTermsAndConditionsDocumentForWholeOrganizationResponseFromJSONTyped(json, false);
}

export function UploadClientTermsAndConditionsDocumentForWholeOrganizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntitiesUpdated': json['legalEntitiesUpdated'],
    };
}

export function UploadClientTermsAndConditionsDocumentForWholeOrganizationResponseToJSON(value?: UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntitiesUpdated': value['legalEntitiesUpdated'],
    };
}

